import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    btn: {
      '&.MuiButton-root': {
        border: '1px solid rgb(188, 188, 188)',
        height: '35px',
        minWidth: '35px',
      },
    },
    menuItem: {
      margin: '0px !important',
      overflow: 'visible',
      display: 'flex',
      justifyContent: 'center',
    },
    contentBtn: {
      backgroundColor: 'white',
      color: 'black',
      width: '90%',
      margin: '15px auto',
      display: 'flex',
      justifyContent: 'center',
      padding: '7px',
      textTransform: 'capitalize',
      borderRadius: 0,
      height: 35,
    },
    grow: {
      background: '#EDEEF2',
    },
    menuList: {
      overflow: 'visible',
      paddingTop: '15px !important',
    },
    typography: {
      color: '#0E1247',
    },
    btnBoutique: {
      margin: theme.spacing(1),
      fontSize: '0.9rem',
      '& span': {
        textTransform: 'none !important',
        fontFamily: 'ITC Avant Garde Gothic Std Medium !important',
        fontWeight: 400,
      },
      '& .MuiButton-startIcon': {
        width: '20% !important',
      },
    },
    btnOAMatch: {
      backgroundColor: 'white',
      color: 'black',
      width: '90%',
      margin: '4vh auto',
      display: 'flex',
      justifyContent: 'center',
      padding: '1vh',
      textTransform: 'capitalize',
      borderRadius: 0,
    },
    textBtn: {
      marginTop: 4,
    },
  })
);
